import React from 'react';
import { motion } from 'framer-motion';

export default function ProtocolBanner() {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-zinc-900/60 border border-zinc-800 rounded-lg p-4 font-mono text-[10px] md:text-xs tracking-wider"
    >
      <div className="flex items-center gap-2 text-emerald-400 mb-2">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 pulse-dot" />
        <span className="tracking-widest uppercase">Site Re-Verified // bsmc.autos</span>
      </div>
      <div className="border-t border-zinc-800 pt-2 space-y-0.5">
        <div>
          <span className="text-zinc-600">PROTOCOL: </span>
          <span className="text-cyan-400">A.U.T.O.S.</span>
          <span className="text-zinc-500"> (AI Universal Tokenomics for Operational Sovereignty)</span>
        </div>
        <div>
          <span className="text-zinc-600">ENGINE: </span>
          <span className="text-amber-400">Hammurabi Medallions</span>
          <span className="text-zinc-500"> (User-Minted NSTF Architecture)</span>
        </div>
      </div>
      <div className="border-t border-zinc-800 mt-2 pt-2">
        <span className="text-zinc-300">Real Digital Income.</span>
        <span className="text-zinc-500"> Zero Speculation.</span>
        <span className="text-zinc-300"> Backed by Data Asset Value.</span>
      </div>
    </motion.div>
  );
}